const DEFAULT_MBI_FAILED_INFO = {
  mbiNotFoundReason: '',
  mbiNotFoundAttemptNumber: 0,
  unavailableReason: '',
  unavailableDetail: '',
}

let mbiFailedInfo = { ...DEFAULT_MBI_FAILED_INFO }

export const getMbiFailedInfo = () => {
  return mbiFailedInfo
}

export const setMbiFailedInfo = ({
  mbiNotFoundReason,
  mbiNotFoundAttemptNumber,
  unavailableReason,
  unavailableDetail,
} = {}) => {
  mbiFailedInfo = {
    ...mbiFailedInfo,
    ...(mbiNotFoundReason !== undefined ? { mbiNotFoundReason } : {}),
    ...(mbiNotFoundAttemptNumber !== undefined
      ? { mbiNotFoundAttemptNumber }
      : {}),
    ...(unavailableReason !== undefined ? { unavailableReason } : {}),
    ...(unavailableDetail !== undefined ? { unavailableDetail } : {}),
  }
}

export const clearMbiFailedInfo = () => {
  mbiFailedInfo = { ...DEFAULT_MBI_FAILED_INFO }
}
